import { useEffect, useState } from 'react';
import { ArenaDialog } from './ArenaDialog.jsx';
import { arenaRequest } from './api.jsx';
import { ma } from './ArenaMedia.jsx';
import { IconHeart, IconTrophy, IconChevronRight, IconSwords } from '../../components/icons.jsx';
import './ArenaHistory.css';

const RESULT_LABELS = { win: 'Победа', loss: 'Поражение', draw: 'Ничья' };

/** @param {{ hp: number, opponent?: boolean }} props */
function HistoryHealth({ hp, maxHp = 100_000, opponent = false }) {
  const value = Math.max(0, hp);
  return <span className={`arena-history-health${opponent ? ' arena-history-health-opponent' : ''}`}>
    <span className="arena-history-health-label"><IconHeart aria-hidden="true" />{opponent ? 'Соперник' : 'Вы'}<b>{ma(value)} <small>HP</small></b></span>
    <span className="arena-history-health-track" aria-hidden="true"><i style={{ width: `${Math.min(100, value / maxHp * 100)}%` }} /></span>
  </span>;
}

/** @param {{ onClose: () => void, onBattle: (battleId: number) => void }} props */
export function ArenaHistory({ onClose, onBattle }) {
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setItems(null);
    setError('');
    arenaRequest('battle/history', {}, controller.signal).then(result => {
      if (!controller.signal.aborted) setItems(result.items);
    }).catch(caught => {
      if (!controller.signal.aborted) setError(caught.message || 'Не удалось загрузить историю');
    });
    return () => controller.abort();
  }, [attempt]);
  return <ArenaDialog title="История боёв" onClose={onClose} busy={false}>
    <div className="arena-history">
      <p className="arena-history-caption">Ваши последние бои</p>
      {error && <div className="arena-history-empty"><p role="alert">{error}</p><button type="button" onClick={() => setAttempt(value => value + 1)}>Попробовать снова</button></div>}
      {!error && !items && <div className="arena-history-loading" role="status">{[0, 1, 2].map(index => <span key={index} />)}<span className="arena-history-sr-only">Загружаем историю боёв</span></div>}
      {items?.length === 0 && <div className="arena-history-empty"><IconSwords aria-hidden="true" /><b>Первый бой ещё впереди</b><p>После боя здесь появятся результат, рейтинг и оставшееся здоровье.</p></div>}
      {items?.length > 0 && <ul className="arena-history-list">{items.map(battle => {
        const result = RESULT_LABELS[battle.result] || RESULT_LABELS.draw;
        const delta = battle.me.ratingDelta ?? 0;
        return <li key={battle.battleId}>
          <button type="button" className={`arena-history-row arena-history-${battle.result}`} onClick={() => onBattle(battle.battleId)}
            aria-label={`${result}. ${battle.opponent.name}. Ваши HP ${ma(Math.max(0, battle.me.hp))}, HP соперника ${ma(Math.max(0, battle.opponent.hp))}. Рейтинг ${delta > 0 ? '+' : ''}${delta}. Открыть бой`}>
            <span className="arena-history-row-top">
              <span className="arena-history-avatar" aria-hidden="true">{battle.opponent.name.trim().charAt(0).toUpperCase() || 'М'}</span>
              <span className="arena-history-identity"><b>{battle.opponent.name}</b><span><em>{result}</em><small>Бой #{battle.battleId}</small></span></span>
              <span className={`arena-history-rating ${delta > 0 ? 'positive' : delta < 0 ? 'negative' : 'neutral'}`} title="Изменение рейтинга"><IconTrophy aria-hidden="true" /><b>{delta > 0 ? '+' : ''}{delta}</b></span>
              <IconChevronRight className="arena-history-chevron" aria-hidden="true" />
            </span>
            <span className="arena-history-health-grid"><HistoryHealth hp={battle.me.hp} maxHp={battle.me.maxHp} /><HistoryHealth hp={battle.opponent.hp} maxHp={battle.opponent.maxHp} opponent /></span>
          </button>
        </li>;
      })}</ul>}
    </div>
  </ArenaDialog>;
}
